/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@ngx-translate/core/src/translate.pipe';
import * as i2 from '@ngx-translate/core/src/translate.service';
import * as i3 from '@angular/common';
import * as i4 from '@angular/router';
import * as i5 from '../../../../../src/app/order/wizard/ordersummary.component';
import * as i6 from '../../../../../src/app/order/order.service';
import * as i7 from '../../../../../src/app/order/currentOrder.service';
import * as i8 from '../../../../../src/app/order/orderValidation';
import * as i9 from '../../../../../src/app/modules/features/flag.service';
import * as i10 from '../../../../../src/app/mixpanel/mixpanel.service';
import * as i11 from '../../../../../src/app/localstorage.service';
var styles_OrderSummaryComponent = [];
export var RenderType_OrderSummaryComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_OrderSummaryComponent, data: {} });
function View_OrderSummaryComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'h3', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['5. ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SUMMARY.TITLE'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'h3', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['3. ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SUMMARY.TITLE'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SUMMARY.MESSAGE_ORDER'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SUMMARY.MESSAGE_QUOTE'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_6(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ' : ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.BILLING.LABEL.PROMO_CODE'));
        var currVal_1 = _co.order.PromoCode;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_OrderSummaryComponent_7(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ' : ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.BILLING.LABEL.FILE_NAME'));
        var currVal_1 = _co.order.POfileName;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_OrderSummaryComponent_5(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 11, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                                                  '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ' : ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                                  '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_6)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                  '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_7)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = (_co.order.PromoCode != '');
        _ck(_v, 7, 0, currVal_2);
        var currVal_3 = (_co.order.POfileName && _co.isFilePOActive);
        _ck(_v, 10, 0, currVal_3);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = i0.ɵunv(_v, 3, 0, i0.ɵnov(_v, 4).transform('ORDER.FORM.SUMMARY.PURCHASE_ORDER'));
        var currVal_1 = _co.order.PurchaseOrderNumber;
        _ck(_v, 3, 0, currVal_0, currVal_1);
    });
}
function View_OrderSummaryComponent_8(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ' : ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.BILLING.LABEL.COMMENTS'));
        var currVal_1 = _co.order.QuestionComment;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_OrderSummaryComponent_9(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'button', [['class',
                'btn btn-default btn-border-blue extra-pad'], ['routerLink', '../billing']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 1).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i4.RouterLink, [i4.Router, i4.ActivatedRoute, [8, null], i0.Renderer2, i0.ElementRef], { routerLink: [0,
                'routerLink'] }, null), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef])], function (_ck, _v) {
        var currVal_0 = '../billing';
        _ck(_v, 1, 0, currVal_0);
    }, function (_ck, _v) {
        var currVal_1 = i0.ɵunv(_v, 2, 0, i0.ɵnov(_v, 3).transform('ORDER.FORM.SUMMARY.EDIT'));
        _ck(_v, 2, 0, currVal_1);
    });
}
function View_OrderSummaryComponent_10(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'button', [['class',
                'btn btn-default btn-border-blue extra-pad'], ['routerLink', '../part']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 1).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i4.RouterLink, [i4.Router, i4.ActivatedRoute, [8, null], i0.Renderer2, i0.ElementRef], { routerLink: [0,
                'routerLink'] }, null), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef])], function (_ck, _v) {
        var currVal_0 = '../part';
        _ck(_v, 1, 0, currVal_0);
    }, function (_ck, _v) {
        var currVal_1 = i0.ɵunv(_v, 2, 0, i0.ɵnov(_v, 3).transform('ORDER.FORM.SUMMARY.EDIT'));
        _ck(_v, 2, 0, currVal_1);
    });
}
function View_OrderSummaryComponent_11(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'th', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SUMMARY.DRAWING'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_12(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'th', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.PARTS.LABEL.SOURCE_SYSTEM'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_13(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'th', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SUMMARY.UOM'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_14(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'th', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SUMMARY.NOTE'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_15(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'th', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SUMMARY.ITEM_FILE'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_17(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.DrawingNum;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_18(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'td', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform(_v.parent.context.$implicit.brand));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_19(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.Uom;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_20(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.Note;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_21(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'td', [['class',
                'word-break-all']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.fileName;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_16(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 29, 'tr', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_17)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_18)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_19)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_20)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_21)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵted(null, ['\n                                                ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.isAlgoliaSearchActive;
        _ck(_v, 9, 0, currVal_2);
        var currVal_3 = _co.isItemBrandActive;
        _ck(_v, 12, 0, currVal_3);
        var currVal_6 = _co.isAlgoliaSearchActive;
        _ck(_v, 21, 0, currVal_6);
        var currVal_7 = _co.isAlgoliaSearchActive;
        _ck(_v, 24, 0, currVal_7);
        var currVal_8 = _co.isFileItemActive;
        _ck(_v, 27, 0, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = (_v.context.index + 1);
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.PartNumber;
        _ck(_v, 6, 0, currVal_1);
        var currVal_4 = _v.context.$implicit.Description;
        _ck(_v, 15, 0, currVal_4);
        var currVal_5 = _v.context.$implicit.Qty;
        _ck(_v, 18, 0, currVal_5);
    });
}
function View_OrderSummaryComponent_22(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class',
                'underline_section clearfix']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 19, 'div', [['class', 'clearfix']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 8, 'div', [['class', 'col-md-10']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵeld(0, null, null, 5, 'div', [['class', 'summary_box']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                            '])), (_l()(), i0.ɵeld(0, null, null, 2, 'h3', [['class', 'summary']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class', 'col-md-2']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵeld(0, null, null, 3, 'button', [['class', 'btn btn-default btn-border-blue extra-pad'],
            ['routerLink', '../shipping']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 17).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i4.RouterLink, [i4.Router, i4.ActivatedRoute, [8, null], i0.Renderer2, i0.ElementRef], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            ']))], function (_ck, _v) {
        var currVal_1 = '../shipping';
        _ck(_v, 17, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 9, 0, i0.ɵnov(_v, 10).transform('ORDER.FORM.SUMMARY.SHIPPING'));
        _ck(_v, 9, 0, currVal_0);
        var currVal_2 = i0.ɵunv(_v, 18, 0, i0.ɵnov(_v, 19).transform('ORDER.FORM.SUMMARY.EDIT'));
        _ck(_v, 18, 0, currVal_2);
    });
}
function View_OrderSummaryComponent_25(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SHIPPING.LABEL.GROUND_SHIPPING'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_26(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SHIPPING.LABEL.OVERNIGHT'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_24(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 8, 'p', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                                            ', ' - \n                                            '])),
        i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_25)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_26)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (_co.order.DeliveryMethod == 'Ground shipping');
        _ck(_v, 4, 0, currVal_1);
        var currVal_2 = (_co.order.DeliveryMethod == 'Overnight');
        _ck(_v, 7, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SHIPPING.LABEL.FEDEX_PREPAID'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_28(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SHIPPING.LABEL.GROUND_SHIPPING'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_29(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SHIPPING.LABEL.OVERNIGHT'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_27(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'p', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ' - ', ' - \n                                            '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_28)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_29)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = (_co.order.DeliveryMethod == 'Ground shipping');
        _ck(_v, 3, 0, currVal_2);
        var currVal_3 = (_co.order.DeliveryMethod == 'Overnight');
        _ck(_v, 6, 0, currVal_3);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order.CourierName;
        var currVal_1 = _co.order.CourierAccountNumber;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_OrderSummaryComponent_31(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SHIPPING.LABEL.GROUND_SHIPPING'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_32(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SHIPPING.LABEL.OVERNIGHT'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_30(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'p', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ' - ', ' - \n                                            '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_31)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_32)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = (_co.order.DeliveryMethod == 'Ground shipping');
        _ck(_v, 3, 0, currVal_2);
        var currVal_3 = (_co.order.DeliveryMethod == 'Overnight');
        _ck(_v, 6, 0, currVal_3);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order.OtherCourierName;
        var currVal_1 = _co.order.CourierAccountNumber;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_OrderSummaryComponent_33(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.SUMMARY.PARTIAL_DELIVERY'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderSummaryComponent_23(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 19, 'div', [['class',
                'clearfix']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 16, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'summary_box']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_24)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_27)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_30)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_33)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵted(null, ['\n                            ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.order.ShippingMethod != 'other');
        _ck(_v, 7, 0, currVal_0);
        var currVal_1 = ((_co.order.ShippingMethod == 'other') && (_co.order.CourierName != 'Other'));
        _ck(_v, 10, 0, currVal_1);
        var currVal_2 = ((_co.order.ShippingMethod == 'other') && (_co.order.CourierName == 'Other'));
        _ck(_v, 13, 0, currVal_2);
        var currVal_3 = (_co.order.IsPartialDelivery == true);
        _ck(_v, 16, 0, currVal_3);
    }, null);
}
function View_OrderSummaryComponent_34(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'li', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                                            '])), (_l()(),
            i0.ɵeld(0, null, null, 4, 'a', [['class', 'btn-add btn-icon'], ['routerLink',
                    '../shipping']], [[1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                if (('click' === en)) {
                    var pd_0 = (i0.ɵnov(_v, 3).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), i0.ɵdid(671744, null, 0, i4.RouterLinkWithHref, [i4.Router, i4.ActivatedRoute, i3.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class',
                'fa-pt pt-b-arr']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                        ']))], function (_ck, _v) {
        var currVal_2 = '../shipping';
        _ck(_v, 3, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 3).target;
        var currVal_1 = i0.ɵnov(_v, 3).href;
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_3 = i0.ɵunv(_v, 5, 0, i0.ɵnov(_v, 6).transform('ORDER.FORM.PREVIOUS'));
        _ck(_v, 5, 0, currVal_3);
    });
}
function View_OrderSummaryComponent_35(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'li', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                                            '])), (_l()(),
            i0.ɵeld(0, null, null, 4, 'a', [['class', 'btn-add btn-icon'], ['routerLink',
                    '../address']], [[1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                if (('click' === en)) {
                    var pd_0 = (i0.ɵnov(_v, 3).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), i0.ɵdid(671744, null, 0, i4.RouterLinkWithHref, [i4.Router, i4.ActivatedRoute, i3.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class',
                'fa-pt pt-b-arr']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                        ']))], function (_ck, _v) {
        var currVal_2 = '../address';
        _ck(_v, 3, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 3).target;
        var currVal_1 = i0.ɵnov(_v, 3).href;
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_3 = i0.ɵunv(_v, 5, 0, i0.ɵnov(_v, 6).transform('ORDER.FORM.PREVIOUS'));
        _ck(_v, 5, 0, currVal_3);
    });
}
export function View_OrderSummaryComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class',
                'text-c']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_1)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_2)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵeld(0, null, null, 256, 'div', [['class',
                'content-inner-wizard']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class', 'message-wizard']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_3)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_4)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 244, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 241, 'div', [['class', 'col-lg-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 238, 'div', [['class', 'wizard content-form']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, null, 235, 'div', [['class', 'content']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 196, 'div', [['class', 'row no-margin form-group']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 0, 'div', [['class', 'col col-bubble']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 191, 'div', [['class', 'col-inputs']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 101, 'div', [['class', 'clearfix']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 40, 'div', [['class', 'col col-lg-6']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 37, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵeld(0, null, null, 26, 'div', [['class', 'col-md-8']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                            '])), (_l()(), i0.ɵeld(0, null, null, 23, 'div', [['class', 'summary_box']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                '])), (_l()(), i0.ɵeld(0, null, null, 2, 'h3', [['class', 'summary']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ' ', ''])), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'p', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, [' ', ' (', ')'])), (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ' ', ''])),
        (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ' '])), (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, [' ', ''])), (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class', 'col-md-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'button', [['class', 'btn m-b-mobile btn-default btn-border-blue extra-pad'],
            ['routerLink', '../address']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 73).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i4.RouterLink, [i4.Router, i4.ActivatedRoute, [8, null], i0.Renderer2, i0.ElementRef], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 54, 'div', [['class', 'col col-lg-6']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                   '])), (_l()(),
            i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 22, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'col-md-8']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                            '])), (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'summary_box']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                '])), (_l()(), i0.ɵeld(0, null, null, 2, 'h3', [['class', 'summary']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ' '])), (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class', 'col-md-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'button', [['class', 'btn m-b-mobile btn-default btn-border-blue extra-pad'],
            ['routerLink', '../part']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 102).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i4.RouterLink, [i4.Router, i4.ActivatedRoute, [8, null], i0.Renderer2, i0.ElementRef], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵted(null, ['\n                                     '])), (_l()(),
            i0.ɵeld(0, null, null, 26, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class', 'col-md-8']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                            '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'summary_box']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                '])), (_l()(), i0.ɵeld(0, null, null, 2, 'h3', [['class', 'summary']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_5)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_8)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class', 'col-md-4 m-b-mobile']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_9)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_10)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class', 'underline_section clearfix no-pad']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 19, 'div', [['class', 'clearfix']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'col-lg-10']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵeld(0, null, null, 5, 'div', [['class', 'summary_box']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                            '])), (_l()(), i0.ɵeld(0, null, null, 2, 'h3', [['class', 'summary']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class', 'col-lg-2']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵeld(0, null, null, 3, 'button', [['class', 'btn m-b-mobile btn-default btn-border-blue extra-pad'],
            ['routerLink', '../part']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 156).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i4.RouterLink, [i4.Router, i4.ActivatedRoute, [8, null], i0.Renderer2, i0.ElementRef], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 53, 'div', [['class', 'clearfix']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 50, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 47, 'div', [['class', 'table-responsive plain']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵeld(0, null, null, 44, 'table', [['class', 'table']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                            '])), (_l()(), i0.ɵeld(0, null, null, 35, 'thead', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 32, 'tr', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'th', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['#'])), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'th', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_11)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_12)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'th', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'th', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_13)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_14)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_15)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'tbody', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_16)),
        i0.ɵdid(802816, null, 0, i3.NgForOf, [i0.ViewContainerRef, i0.TemplateRef,
            i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                                            '])), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_22)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_23)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 31, 'div', [['class', 'row no-margin']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 0, 'div', [['class', 'col col-bubble']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 26, 'div', [['class', 'col-inputs']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 23, 'div', [['class', 'col']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'order_buttons_holder']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 17, 'ul', [['class', 'order_buttons']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_34)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderSummaryComponent_35)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 2, 'button', [['class', 'btn btn-default btn-cancel extra-pad btn-lg']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.showCancelAlert() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 2, 'button', [['class', 'btn extra-pad btn-lg btn-primary'],
            ['id', 'submit-form']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.submit() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = (_co.orderType.lowercaseType == 'quote');
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 14, 0, currVal_2);
        var currVal_3 = (_co.orderType.lowercaseType == 'quote');
        _ck(_v, 17, 0, currVal_3);
        var currVal_15 = '../address';
        _ck(_v, 73, 0, currVal_15);
        var currVal_19 = '../part';
        _ck(_v, 102, 0, currVal_19);
        var currVal_22 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 119, 0, currVal_22);
        var currVal_23 = (_co.order.QuestionComment != '');
        _ck(_v, 122, 0, currVal_23);
        var currVal_24 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 129, 0, currVal_24);
        var currVal_25 = (_co.orderType.lowercaseType == 'quote');
        _ck(_v, 132, 0, currVal_25);
        var currVal_27 = '../part';
        _ck(_v, 156, 0, currVal_27);
        var currVal_30 = _co.isAlgoliaSearchActive;
        _ck(_v, 183, 0, currVal_30);
        var currVal_31 = _co.isItemBrandActive;
        _ck(_v, 186, 0, currVal_31);
        var currVal_34 = _co.isAlgoliaSearchActive;
        _ck(_v, 197, 0, currVal_34);
        var currVal_35 = _co.isAlgoliaSearchActive;
        _ck(_v, 200, 0, currVal_35);
        var currVal_36 = _co.isFileItemActive;
        _ck(_v, 203, 0, currVal_36);
        var currVal_37 = _co.order.Items;
        _ck(_v, 211, 0, currVal_37);
        var currVal_38 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 220, 0, currVal_38);
        var currVal_39 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 223, 0, currVal_39);
        var currVal_40 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 242, 0, currVal_40);
        var currVal_41 = (_co.orderType.lowercaseType == 'quote');
        _ck(_v, 245, 0, currVal_41);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_4 = i0.ɵunv(_v, 47, 0, i0.ɵnov(_v, 48).transform('ORDER.FORM.SUMMARY.SHIP_TO'));
        _ck(_v, 47, 0, currVal_4);
        var currVal_5 = _co.order.Contact.CompanyName;
        _ck(_v, 51, 0, currVal_5);
        var currVal_6 = _co.order.Contact.FirstName;
        var currVal_7 = _co.order.Contact.LastName;
        _ck(_v, 54, 0, currVal_6, currVal_7);
        var currVal_8 = _co.order.ShippingAddress.Line;
        _ck(_v, 57, 0, currVal_8);
        var currVal_9 = _co.order.ShippingAddress.City;
        var currVal_10 = _co.order.ShippingAddress.StateProvince;
        _ck(_v, 59, 0, currVal_9, currVal_10);
        var currVal_11 = _co.order.ShippingAddress.PostalCode;
        var currVal_12 = _co.order.ShippingAddress.Country.Name;
        _ck(_v, 61, 0, currVal_11, currVal_12);
        var currVal_13 = _co.order.Contact.Phone;
        _ck(_v, 64, 0, currVal_13);
        var currVal_14 = _co.order.Contact.Email;
        _ck(_v, 66, 0, currVal_14);
        var currVal_16 = i0.ɵunv(_v, 74, 0, i0.ɵnov(_v, 75).transform('ORDER.FORM.SUMMARY.EDIT'));
        _ck(_v, 74, 0, currVal_16);
        var currVal_17 = i0.ɵunv(_v, 91, 0, i0.ɵnov(_v, 92).transform('ORDER.FORM.SUMMARY.EQUIPMENT_BRAND'));
        _ck(_v, 91, 0, currVal_17);
        var currVal_18 = _co.order.Brand.Name;
        _ck(_v, 95, 0, currVal_18);
        var currVal_20 = i0.ɵunv(_v, 103, 0, i0.ɵnov(_v, 104).transform('ORDER.FORM.SUMMARY.EDIT'));
        _ck(_v, 103, 0, currVal_20);
        var currVal_21 = i0.ɵunv(_v, 115, 0, i0.ɵnov(_v, 116).transform('ORDER.FORM.SUMMARY.ADDITIONAL_INFO'));
        _ck(_v, 115, 0, currVal_21);
        var currVal_26 = i0.ɵunv(_v, 148, 0, i0.ɵnov(_v, 149).transform('ORDER.MAIN_COMPONENT.MENU.PARTS'));
        _ck(_v, 148, 0, currVal_26);
        var currVal_28 = i0.ɵunv(_v, 157, 0, i0.ɵnov(_v, 158).transform('ORDER.FORM.SUMMARY.EDIT'));
        _ck(_v, 157, 0, currVal_28);
        var currVal_29 = i0.ɵunv(_v, 179, 0, i0.ɵnov(_v, 180).transform('ORDER.FORM.SUMMARY.ITEM'));
        _ck(_v, 179, 0, currVal_29);
        var currVal_32 = i0.ɵunv(_v, 189, 0, i0.ɵnov(_v, 190).transform('ORDER.FORM.SUMMARY.DESCRIPTION'));
        _ck(_v, 189, 0, currVal_32);
        var currVal_33 = i0.ɵunv(_v, 193, 0, i0.ɵnov(_v, 194).transform('ORDER.FORM.SUMMARY.QUANTITY'));
        _ck(_v, 193, 0, currVal_33);
        var currVal_42 = i0.ɵunv(_v, 249, 0, i0.ɵnov(_v, 250).transform('ORDER.FORM.CANCEL'));
        _ck(_v, 249, 0, currVal_42);
        var currVal_43 = !_co.isValid();
        _ck(_v, 253, 0, currVal_43);
        var currVal_44 = i0.ɵunv(_v, 254, 0, i0.ɵnov(_v, 255).transform('ORDER.FORM.SUBMIT'));
        _ck(_v, 254, 0, currVal_44);
    });
}
export function View_OrderSummaryComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'cx-ordersummary', [], null, null, null, View_OrderSummaryComponent_0, RenderType_OrderSummaryComponent)), i0.ɵdid(114688, null, 0, i5.OrderSummaryComponent, [i6.OrderService, i7.CurrentOrderService, i8.OrderValidation, i4.Router, i2.TranslateService,
            i9.FlagService, i4.ActivatedRoute, i10.MixpanelService, i11.LocalStorageService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var OrderSummaryComponentNgFactory = i0.ɵccf('cx-ordersummary', i5.OrderSummaryComponent, View_OrderSummaryComponent_Host_0, {}, {}, []);
//# sourceMappingURL=ordersummary.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/order/wizard/ordersummary.component.ngfactory.js
// module id = 1195
// module chunks = 0